import React from "react";
import { SpacerContainer } from "./Spacer-styles";

export interface SpacerProps {
  line?: boolean | string;
  size: number | string;
}

interface PropTypes extends SpacerProps {}

function Spacer(props: PropTypes) {
  return <SpacerContainer {...props} />;
}

export default Spacer;
